import React from 'react';
import agentPageStore from '../store';
import { observer } from 'mobx-react-lite';
import { McpAgentType } from '@shared/constants/mcp';
import urlStore from '@/store/chat/urlStore';
import AagentMenu from './agent-menu';
import TipsMcp from './tips-mcp';
import Conf from '@/common/conf';
import TipsSuper from './tips-super';
import globalStore from '@/store/global';

const BlockListItem = ({ item, isRecommend, showMenu, isMine }) => {

  /** 跳转去聊天 */
  const gotoChat = () => {
    if (item.agent_type == McpAgentType.old) {
      urlStore.newAgentChat(item.id);
    } else {
      agentPageStore.gotoAgentChat(item.id);
    }
  }

  return (
    <div
      onClick={gotoChat}
      key={item.id}
      className={[
        'relative group bg-white hover:bg-[#f7f7f7]',
        'flex items-center h-118px px-16px cursor-pointer rounded-8px',
        isRecommend || isMine
          ? 'border-1px border-black border-opacity-16'
          : '',
        isMine ? "bg-[rgba(0,0,0,0.02)] hover:bg-[rgba(0,0,0,0.03)]" : ""
        //showDropdown ? 'bg-[rgba(0,0,0,0.03)]' : '',
      ]}
    >
      <div
        className={[
          isRecommend ? 'size-80px' : 'size-64px',
          'mr-12px rounded-full overflow-hidden',
        ]}
      >
        <img
          src={
            item.icon || Conf.agentIocn
          }
          className="size-full object-cover"
          alt=""
        />
      </div>

      <div className="flex-grow w-0">
        <div className="w-full flex items-center text-16px text-black font-bold leading-22px mb-2px truncate">
          <div className="truncate">{item.title}</div>
          {[McpAgentType.normal, McpAgentType.simple].includes(
            item.agent_type * 1
          ) ? (
            <TipsMcp />
          ) : null}
          {
            globalStore.isLimitedAgent(item.id)
            ? <TipsSuper className="ml-6px" tip='vip' />
            : null
          }
        </div>
        <div className="text-12px text-black leading-17px my-4px line-clamp-2">
          {item.greeting || item.intro}
        </div>
        <div className="text-12px text-black text-opacity-50 leading-20px truncate">
          创建者：{item.creator}
        </div>
      </div>
      {/* 只有我创建的才可以有编辑入口 */}
      {showMenu ? (
        <AagentMenu
          className="absolute right-16px bottom-12px group-hover:block"
          item={item}
        />
      ) : null}
    </div>
  );
};



const BlockList = observer(
  ({ list, isRecommend = false, isMine = false, showMenu = false }) => {
    return (
      <div
        className={[
          'w-full grid gap-16px grid-cols-2',
        ]}
      >
        {list.map(item => {
          return (
            <BlockListItem
              key={item.id}
              item={item}
              isRecommend={isRecommend}
              showMenu={showMenu}
              isMine={isMine}
            />
          );
        })}

      </div>
    );
  }
);

export default BlockList;
